import React from 'react';

// Shared "V2 is down" banner. Default fallback for withV2HealthCheck; also rendered
// directly by new_request/V2SyncGate.
function MaintenanceMessage() {
  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '400px' }}>
      <div className="text-center" style={{ maxWidth: '500px', padding: '2rem' }}>
        <div className="mb-4">
          <i className="fa-solid fa-wrench fa-3x text-warning" />
        </div>
        <h3 className="mb-3">Temporarily Unavailable</h3>
        <p className="text-muted mb-4">
          We&apos;re currently performing some maintenance on our systems.
          We&apos;ll be back up and running soon.
        </p>
        <p className="text-muted small">
          Please check back in a few minutes or contact
          {' '}
          <a href="mailto:support@qwoted.com">support@qwoted.com</a>
          {' '}
          if this persists.
        </p>
      </div>
    </div>
  );
}

export default MaintenanceMessage;
